/**
 * UUID Generation Utility
 */

/**
 * Generate RFC4122 compliant UUID with timestamp suffix
 * Used for creating unique session and user identifiers
 * @returns UUID string with timestamp suffix for additional uniqueness
 */
export function generateUUID(): string {
  return (
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }) + Date.now().toString(16)
  );
}
